<template>
    <div>
    <div class="header-tool">
        <div class="header-tool-info">
            <Breadcrumb>
                <BreadcrumbItem>首页</BreadcrumbItem>
                <BreadcrumbItem>通用设置</BreadcrumbItem>
                <BreadcrumbItem>短信模板</BreadcrumbItem>
            </Breadcrumb>
            <div class="header-tool-title">短信模板</div>
        </div>

<!--        <div class="header-tool-box">-->
<!--            <div class="htb-item" @click="showAdd()">-->
<!--                <span>添加省级</span>-->
<!--            </div>-->
<!--        </div>-->
    </div>
        <div class="header-tabs">
            <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
                <TabPane label="短信模板" name="1">
                    <messageModel ref="supplyUserCheck" v-if="showTabs === '1'" />
                </TabPane>
                <TabPane label="短信账号" name="2">
                    <messageAccount ref="supplyUserPass" v-if="showTabs === '2'" />
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import messageModel from "../components/host-common-messageModel"
    import messageAccount from "../components/host-common-messageAccount"
    export default {
        // 模板内容
        name: "live-set-note-con",
        props: {

        },
        data() {
            return {
                visible:false,
                list: [],
                checkItem:{},
                pageSize: 20,
                pageIndex: 1,
                totalCount: 0,
                showTabs: "1"
            };
        },
        computed: {
            ...mapGetters({
                hostId: "getHostId",
                exhibitionId: "getExhibitionId",
            }),

        },
        created() {
            this.init();
        },
        components: {
            messageModel,
            messageAccount
        },

        methods: {
            ...mapActions({
                getNote:"getNote"
            }),
            switchBrand() {
            },
            async init(){
                let res = await this.getNote()
                this.list=res
                console.log(res,'resssssssssss')
            },
            edit(item){
                this.checkItem=JSON.parse(JSON.stringify(item)) ;
                this.visible=true;
            },

            async ok(){
                if(!this.checkItem.contents){
                    this.$Message.error('内容不能为空');
                    return
                }
                let req={
                    id:this.checkItem.id,
                    opt:{
                        contents:this.checkItem.contents,
                    }
                }
                let res=await this.editSmsTemp(req);
                if(res&&res.result){
                    this.$Message.success('保存成功');
                    this.visible=false;
                    this.init();
                }else{
                    this.$Message.error(res.message);
                }
            },
            cancal(){
                this.visible=false
            }
        },
    };
</script>

<style scoped lang="scss">

</style>
